import 'twin.macro'

import DoubleCheckedIcon from 'assets/icons/DoubleCheckedIcon'
import { Button } from 'components/UI/button/button'
import Modal from 'components/UI/modal/modal'
import SubTitle from 'components/UI/sub-title/sub-title'
import Title from 'components/UI/title/title'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ClipLoader } from 'react-spinners'
import { useGetStatusQuery } from 'redux/api/status.api'
import { mobilePhoneSelector, setIsBuyLanding } from 'redux/store/slices/application-slice'
import { setError } from 'redux/store/slices/error-slice'
import tw from 'twin.macro'
import { pathnames } from 'utils/steps'

function PendingPage() {
  const { t } = useTranslation()
  const [open, setOpen] = useState<boolean>(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  // const uuid = useSelector(applicationUuidSelector)
  const { data: status } = useGetStatusQuery(null, { pollingInterval: 10000, skip: open })
  const onClose = () => {
    setOpen(false)
  }
  const mobile_phone = useSelector(mobilePhoneSelector)

  useEffect(() => {
    if (status?.data.pan_card) {
      dispatch(setIsBuyLanding(true))
      navigate(pathnames['personal-cabinet'])
    }
    if (status?.data.status === 'REJECTED') {
      const description = status?.data.reason || t('generic_error', { ns: 'badcases' })
      dispatch(setError({ code: 'REJECTED', description }))
      navigate(pathnames.error)
    }
    if (status?.data.status === 'CANCELED') {
      const description = status?.data.reason || t('generic_error', { ns: 'badcases' })
      dispatch(setError({ code: 'CANCELED', description }))
      navigate(pathnames.error)
    }
    if (!status?.data.pan_card && status?.data.status !== 'REJECTED' && status?.data.status !== 'CANCELED' && (status?.data.reason || status?.error)) {
      const description = status?.data.reason || t('generic_error', { ns: 'badcases' })
      dispatch(setError({ code: status?.data.status || 'ERROR', description }))
      navigate(pathnames.error)
    }
  }, [status])

    useEffect(() => {
    if (status?.data.status === 'CANCELED') {
      dispatch(setError({code:status?.data.status, description: t("canceled", { ns: 'badcases' }) }))
    }
  }, [status])


  return (
    <>
      {!open && (
        <div tw='bg-secondary w-full p-10 rounded-2xl flex flex-col gap-10 items-center justify-center'>
          <ClipLoader />
          <SubTitle>{t('payment-proccess', { ns: 'cabinet' })}</SubTitle>
        </div>
      )}
      <Modal open={open} onClose={onClose} withClose={false} outsideClose={false}>
        <div tw='p-10 flex flex-col items-center gap-5'>
          <DoubleCheckedIcon />
          <Title variant='bold'>{t('success.title', { ns: 'cabinet' })}</Title>
          <SubTitle twStyle={tw`text-secondary text-center max-w-[300px]`}>
            {t('success.desc', { ns: 'cabinet', phone: mobile_phone })}
          </SubTitle>
        </div>
        <Button variant='gradient' onClick={() => setOpen(false)}>
          {' '}
          {t('success.close', { ns: 'cabinet' })}
        </Button>
      </Modal>
    </>
  )
}

export default PendingPage
